import React from 'react';
import {Carousel} from "../basic/full-screen-slider/full-screen-slider";
import { wrapCollectionLayout } from "@quintype/components";

function FullScreenSliderBase({collection, stories = [], associatedMetadata, metadata, config = {}}) {
  const slidesToScroll = associatedMetadata.slidesToScroll ? parseInt(associatedMetadata.slidesToScroll) : undefined;
  const slidesToShow = associatedMetadata.slidesToShow ? parseInt(associatedMetadata.slidesToShow) : undefined;
  const carouselProps = Object.assign({}, {stories, config, metadata, collection}, associatedMetadata, {slidesToScroll, slidesToShow});
  return React.createElement(Carousel, carouselProps);
}

export const FullImageSlider = wrapCollectionLayout(FullScreenSliderBase);
